import { cn } from "../../lib/utils";
import { ScrollArea } from "./scroll-area";
import { Separator } from "./separator";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./tabs";

export const FloatingPanelGroup = (props: React.ComponentProps<"div">) => (
  <div
    {...props}
    className={cn("bg-transparent flex flex-col gap-2 m-4", props.className)}
  />
);

export const FloatingPanel = (props: React.ComponentProps<"div">) => (
  <div
    {...props}
    className={cn(
      "bg-card overflow-hidden rounded-md shadow border w-[300px]",
      props.className,
    )}
  />
);

export const FloatingPanelTabs = (props: React.ComponentProps<typeof Tabs>) => (
  <Tabs {...props} className={cn("py-0", props.className)} />
);

export const FloatingPanelTabsList = (
  props: React.ComponentProps<typeof TabsList>,
) => (
  <TabsList
    {...props}
    className={cn("bg-transparent p-0 py-0 inline-flex", props.className)}
  />
);

export const FloatingPanelTabsTrigger = (
  props: React.ComponentProps<typeof TabsTrigger>,
) => (
  <TabsTrigger
    {...props}
    className={cn(
      "bg-transparent data-[state=active]:bg-secondary data-[state=active]:shadow-none text-xs",
      props.className,
    )}
  />
);

export const FloatingPanelTabsContent = ({
  children,
  ...props
}: React.ComponentProps<typeof TabsContent>) => (
  <TabsContent {...props}>
    <ScrollArea className="h-96 flex pb-2">{children}</ScrollArea>
  </TabsContent>
);

export const FloatingPanelSectionTitle = (
  props: React.ComponentProps<"span">,
) => (
  <span
    {...props}
    className={cn(
      "py-2 font-medium text-md flex items-center gap-2",
      props.className,
    )}
  />
);

export const FloatingPanelContent = (props: React.ComponentProps<"div">) => (
  <div {...props} className={cn("p-2 flex flex-col gap-2", props.className)} />
);

export const FloatingPanelHeader = (props: React.ComponentProps<"div">) => (
  <div
    {...props}
    className={cn(
      "p-2 bg-card font-medium text-xs flex items-center gap-2",
      props.className,
    )}
  />
);

export const FloatingPanelSeparator = (
  props: React.ComponentProps<typeof Separator>,
) => <Separator {...props} className={cn("", props.className)} />;

export const FloatingBarGroup = (props: React.ComponentProps<"div">) => (
  <div
    {...props}
    className={cn("z-10 bg-transparent flex gap-2 m-4", props.className)}
  />
);

export const FloatingBar = (props: React.ComponentProps<"div">) => (
  <div
    {...props}
    className={cn(
      "bg-card overflow-hidden transition-all flex gap-2 p-1 rounded-full shadow border min-w-[32px] flex items-center justify-center",
      props.className,
    )}
  />
);
